import { aboutMock } from "./aboutMock";
import { accountsMock } from "./accountsMock";
import { affiliatesMock } from "./affiliatesMock";
import { cfdTradingMock } from "./cfdTradingMock";
import { contactUsMock } from "./contactUsMock";
import { faqMock } from "./faqMock";
import { feesAndChargesMock } from "./feesAndChargesMock";
import { privacyPolicyMock } from "./privacyPolicyMock";
import { termsAndConditionsMock } from "./termsAndConditionsMock";
import { whyUsMock } from "./whyUsMock";
import { tradingMock } from "./tradingMock";
import { depositsAndWithdrawalsMock } from "./depositsAndWithdrawalsMock";
import { whatIsForexTradingMock } from "./whatIsForexTradingMock";
import { whatIsCfdTradingMock } from "./whatIsCfdTradingMock";
import { whatIsCryptocurrencyTradingMock } from "./whatIsCryptocurrencyTradingMock";
import { cryptocurrencyTradingMock } from "./cryptocurrencyTradingMock";
import { tradingPlatformsMock } from "./tradingPlatformsMock";

export const MOCK_PAGES = {
  // about: aboutMock,
  // accounts: accountsMock,
  // affiliates: affiliatesMock,
  // "cfd-trading": cfdTradingMock,
  // "contact-us": contactUsMock,
  // faq: faqMock,
  // "fees-and-charges": feesAndChargesMock,
  // "privacy-policy": privacyPolicyMock,
  // "terms-and-conditions": termsAndConditionsMock,
  // "why-us": whyUsMock,
  // trading: tradingMock,
  // "deposits-and-withdrawals": depositsAndWithdrawalsMock,
  // "what-is-forex-trading": whatIsForexTradingMock,
  // "what-is-cfd-trading": whatIsCfdTradingMock,
  // "what-is-cryptocurrency-trading": whatIsCryptocurrencyTradingMock,
  // "cryptocurrency-trading": cryptocurrencyTradingMock,
  // "trading-platforms": tradingPlatformsMock,
};
